import { CommonDialogs } from "@mcleod/common";
import { Checkbox, DropdownItem, Label, Panel, Textbox } from "@mcleod/components";
import { DisplayType, HorizontalAlignment } from "@mcleod/core";

export class AdjustDistanceRateTable {
    static async showModal(sourceId: string) {
        const panelPrompt = new Panel({rowBreakDefault: false, align: HorizontalAlignment.CENTER});
        panelPrompt.add(new Label({fontBold: true, text: `You are adjusting the rates for table: ${sourceId}`, rowBreak: true}));
        panelPrompt.add(new Label({text: "All customer rates using this table will be affected.", rowBreak: true}));
        const tbType = new Textbox({
            id: "tbType", 
            required: true, 
            allowDropdownBlank: false, 
            items: [
                new DropdownItem("I", "Increase"),
                new DropdownItem("D", "Decrease")
            ]
        });
        const tbPercent = new Textbox({
            id: "tbPercent", 
            required: true,
            width: 75, 
            displayType: DisplayType.INTEGER, 
            minValue: 1
        });
        const cbMinimum = new Checkbox({
            id: "cbMinimum",
            caption: "Adjust Minimum Charges",
            checked: false
        })
        panelPrompt.add(
            tbType, 
            new Label({text: "by", marginTop: 8}),
            tbPercent,
            new Label({text: "%", marginTop: 8, rowBreak: true}),
            cbMinimum
        );
        return CommonDialogs.showYesNo(panelPrompt, "Adjust Table Rate", {
            yesButtonCaption: "Save",
            noButtonCaption: "Cancel"
        }).then((saved) => 
            saved ? {
                type: tbType.selectedItem.value,
                percent: tbPercent.text,
                adjustMinimum: cbMinimum.checked
            } : null
        ).catch(() => null);
    }
}   